import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IEvent } from '@interfaces/IEvent';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IEventFile } from '@interfaces/IEventFile';

@Injectable({
  providedIn: 'root',
})
export class EventsChangesService {
  constructor(private _http: HttpClient) {}

  create(event: IEvent): Observable<{ detail: string; id: number }> {
    const url = `${environment.baseUrl}api/v1/events/`;
    return this._http.post<{ detail: string; id: number }>(url, event);
  }

  edit(id: number, event: IEvent): Observable<IEvent> {
    const url = `${environment.baseUrl}api/v1/events/${id}/`;
    return this._http.patch<IEvent>(url, event);
  }

  delete(event: IEvent): Observable<{ detail: string }> {
    const url = `${environment.baseUrl}api/v1/events/${event.id}`;
    return this._http.delete<{ detail: string }>(url);
  }

  addFile(data: FormData): Observable<IEventFile> {
    const url = `${environment.baseUrl}api/v1/event-files/`;
    return this._http.post<IEventFile>(url, data);
  }
}
